import React from "react";
import { Link } from "react-router-dom";
import "../CSS/Resume.css";
import resumePDF from "./assets/resume_no-call.pdf"; // Import the resume PDF
import ResumeData from "../data/ResumeData"; // Import ResumeData

const Resume = () => {
  const { experiences, education, skills,memberat } = ResumeData;

  return (
    
    <div className="resume">
    {/* Download Resume Section */}
    <section>
        <h2>Download Resume</h2>
        <a href={resumePDF} download className="download-btn">Download</a>
      </section>
      <h1>Resume</h1>
      <div className="exps">
      {/* Experience Section */}
      <section>
        <h2>Experience</h2>
        <ul>
          {experiences.map((exp, idx) => (
            <li key={idx}>
              <span>{exp.date}</span>
              <h3>{exp.title} at {exp.company}</h3>
              <p>{exp.description}</p>
            </li>
          ))}
        </ul>
      </section>
      
      {/* Education Section */}
      <section>
        <h2>Education</h2>
        <ul>
          {education.map((edu, idx) => (
            <li key={idx}>
              <span>{edu.date}</span>
              <h3>{edu.degree}</h3>
              <p>{edu.institution}</p>
            </li>
          ))}
        </ul>
      </section>

       {/* Members Section */}
       <section>
        <h2>Member @ </h2>
        <ul>
          {memberat.map((mem, idx) => (
            <li key={idx}>
              <span>{mem.date}</span>
              <h4>{mem.role}</h4>
              <p><strong>{mem.company}</strong></p>
{/*           <p>==> {mem.title}</p>        */}
            </li>
          ))}
        </ul>
      </section>
      
      {/* Skills Section */}
      <section>
        <h2>Skills</h2>
        <ul className="skills-list">
          {skills.map((skill, idx) => <li key={idx}>{skill}</li>)}
        </ul>
      </section>
      
      
    </div>
    </div>
  );
};

export default Resume;